
import { CartLinesUpdateEvent } from "@shopify/events";
(() => {
  if (window.AtelierPackagingLoaded) return;
  window.AtelierPackagingLoaded = true;

  const money = (cents) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(cents / 100);

  function setupCard(card) {
    if (card.dataset.atelierReady) return;
    card.dataset.atelierReady = "true";

    const wrapper = card.closest("product-card");
    if (!wrapper) return;

    const buttons = [...card.querySelectorAll(
      ".atelier-packaging-option"
    )];

    const price = card.querySelector(
      ".atelier-packaging-price"
    );

    const addButton = card.querySelector(
      "[data-atelier-add]"
    );

    const message = card.querySelector(
      "[data-atelier-message]"
    );

    const gallery = wrapper.querySelector(".card-gallery");

    let selectedId = card.dataset.selectedVariant;

    function selectVariant(button) {
      selectedId = button.dataset.variantId;

      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle("is-selected", active);
        item.setAttribute("aria-pressed", String(active));
      });

      price.textContent = button.dataset.variantPrice;

      const available =
        button.dataset.variantAvailable === "true";

      addButton.disabled = !available;
      addButton.textContent = available
        ? "Add to cart"
        : "Sold out";

      message.textContent = "";

      const imageUrl = button.dataset.variantImage;

if (gallery && imageUrl) {
  let overlay = gallery.querySelector(
    ".atelier-variant-image"
  );

  if (!overlay) {
    overlay = document.createElement("img");
    overlay.className = "atelier-variant-image";
    overlay.alt = "Selected packaging option";
    overlay.style.pointerEvents = "none";
    gallery.appendChild(overlay);
  }

  overlay.src = imageUrl;
  overlay.style.display = "block";
  overlay.style.pointerEvents = "none";
} else {
  gallery?.querySelector(
    ".atelier-variant-image"
  )?.remove();
}

      const productLink = wrapper.querySelector(
        ".product-card__link"
      );

      if (productLink) {
        const url = new URL(productLink.href);
        url.searchParams.set("variant", selectedId);
        productLink.href = url.toString();
      }
    }

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        selectVariant(button);
      });
    });

    
addButton.addEventListener("click", async (event) => {
  event.preventDefault();
  event.stopPropagation();

  if (addButton.disabled) return;

  addButton.disabled = true;
  addButton.textContent = "Adding...";
  message.textContent = "";

  const deferredEventPromise = CartLinesUpdateEvent.createPromise();

  addButton.dispatchEvent(
    new CartLinesUpdateEvent({
      action: "add",
      context: "product",
      lines: [
        {
          merchandiseId: String(selectedId),
          quantity: 1
        }
      ],
      promise: deferredEventPromise.promise
    })
  );

  try {
    const root = window.Shopify?.routes?.root || "/";

    const response = await fetch(root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(selectedId),
        quantity: 1
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || "Could not add to cart"
      );
    }

    const cartResponse = await fetch(root + "cart.js");

    if (!cartResponse.ok) {
      throw new Error("Could not refresh cart");
    }

    const ajaxCart = await cartResponse.json();

    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: "atelier-packaging",
        sourceId: String(selectedId),
        itemCount: 1,
        productId: String(card.dataset.productId || ""),
        didError: false
      }
    });

    addButton.textContent = "Added!";
    message.textContent = "Added to your cart.";

    setTimeout(() => {
      addButton.disabled = false;
      addButton.textContent = "Add to cart";
    }, 1200);

  } catch (error) {
    deferredEventPromise.reject(error);

    message.textContent = error.message;
    addButton.disabled = false;
    addButton.textContent = "Add to cart";
  }
});


    const selected = buttons.find(
      (button) => button.dataset.variantId === selectedId
    ) || buttons[0];

    if (selected) selectVariant(selected);
  }

  function initialize() {
    document.querySelectorAll(
      "[data-atelier-packaging]"
    ).forEach(setupCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded", initialize
    );
  } else {
    initialize();
  }

  document.addEventListener(
    "shopify:section:load", initialize
  );
})();
